import {Type} from 'class-transformer';
import {
  IsArray,
  IsBoolean,
  IsInt,
  IsNumber,
  IsOptional,
  IsString,
  ValidateNested,
} from 'class-validator';

export class ContactUserEventPayloadDto {
  @IsInt()
  userEventId!: number;

  @IsInt()
  raiseDateTime!: number;
}

export class CreateContactRequestDto {
  @IsString()
  firstName!: string;

  @IsString()
  lastName!: string;

  @IsNumber()
  mobile!: number;

  @IsString()
  email!: string;

  @IsOptional()
  @IsString()
  address!: string | null;

  @IsOptional()
  @IsBoolean()
  isMale!: boolean | null;

  @IsArray()
  @ValidateNested({each: true})
  @Type(() => ContactUserEventPayloadDto)
  userEvents!: ContactUserEventPayloadDto[];
}
